import { Map } from 'immutable';
import { LoadingStatusEnum, TranslatingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_TRANSLATE_TEXTS,
	START_TRANSLATE_TEXTS_SUCCESS,
	START_TRANSLATE_TEXTS_FAILED,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	translatedData: Map(),
	translatingStatusMap: Map(),

	// 保留以維持與 cs／management-console 一致的 reducer 形狀,client-console 目前無讀取端
	loadingStatus: NONE,
	loadingStatusMessage: '',
});

export default function translate(state = initialState, action) {
	switch (action.type) {
		case START_TRANSLATE_TEXTS: {
			const {
				translateKey,
			} = action;

			// 只擋真正翻譯中的 key;FAILED 的 key 重派(手動重試)時重新標記為翻譯中
			if (state.getIn(['translatingStatusMap', translateKey]) === TranslatingStatusEnum.TRANSLATING) {
				return state;
			}

			return state
				.update('translatingStatusMap', statusMap => statusMap.set(translateKey, TranslatingStatusEnum.TRANSLATING))
				.set('loadingStatus', LOADING);
		}

		case START_TRANSLATE_TEXTS_SUCCESS: {
			const {
				translateKey,
				translatedTexts,
			} = action;

			return state
				.update('translatedData', translatedData => translatedData.set(translateKey, translatedTexts))
				.update('translatingStatusMap', statusMap => statusMap.set(translateKey, TranslatingStatusEnum.DONE))
				.set('loadingStatus', SUCCESS);
		}

		case START_TRANSLATE_TEXTS_FAILED:
			return state
				.update('translatingStatusMap', statusMap =>
					(action.translateKey ? statusMap.set(action.translateKey, TranslatingStatusEnum.FAILED) : statusMap))
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		default:
			return state;
	}
}
